<div class="service-summary pb-130">
  <div class="flex-col">
    <div class="max-width-lg bg-gradient pt-16">
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
      <div class="flex flex-row">
        <div class="flex flex-row items-center mb-40">
          <div class="mr-32">
            <mat-icon svgIcon="arrow_back" class="icon cursor-pointer"></mat-icon>

            <!-- <mat-icon svgIcon="arrow_back" class="icon cursor-pointer" [routerLink]="['/', tenant, RouterSegments.CATALOGUE]"></mat-icon> -->
          </div>
          <div>
            <div class="flex-row mb-10 mr-24">
              <div class="mat-headline-3 mb-0 mr-32">{{ service?.name }}</div>
            </div>
            <div class="mat-body-1 fw-bold">{{ service?.tagline}}</div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="serviceCardInfos?.length > 0">
        <div class="flex-row"> 
          <mat-divider class="mb-24"></mat-divider> 
        </div>
      </ng-container>
     
    </div>
    <div *ngIf="dataLoaded">
      <div class="max-width-lg bg-gradient">
        <div class="flex-row">
          <div class="flex flex-row">
            <ng-container *ngIf="isInstance && serviceCardInfos?.length > 0; else showNoActiveBlueprintsOrSandbox">
              <ng-container *ngIf="serviceCardInfos?.length > 4 && !permissionsMap[Permission.NO_SERVICES]; else showNoCarouselBlueprintsOrSandbox">
                <app-carousel [items]="serviceCardInfos" [numDisplayedItems]="4" class="m-auto">
                  <ng-template #itemTemplate let-serviceCardInfo>
                    <app-card [serviceCardInfo]="serviceCardInfo"
                              [serviceVersions]="serviceVersions"
                              (blueprintDeleted)="onBlueprintDeleted($event)"
                              class="flex mb-24 service-card-info">
                    </app-card>
                  </ng-template>
                </app-carousel>
              </ng-container>
              <ng-template #showNoCarouselBlueprintsOrSandbox>
                <app-card *ngFor="let serviceCardInfo of serviceCardInfos"
                          [serviceCardInfo]="serviceCardInfo"
                          [serviceVersions]="serviceVersions"
                          (blueprintDeleted)="onBlueprintDeleted($event)"
                          class="flex pl-12 pr-12 mb-24">
                </app-card>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  <app-service-tabs-content *ngIf="dataLoaded" [solutionVersion]="solutionVersion" [service]="service" [capabilityDescription]="capabilityDescription" [capabilities]="capabilities" [selectedCapabilities]="selectedCapabilities" [displayStartFreeTrialButton]="displayStartFreeTrialButton"></app-service-tabs-content>
  </div>
</div>
